export enum ContactItemType {
    Interaction = 0,
    Email,
    Message,
    Task,
}
